/**
 * Status tones for the report's pills, dots and bars. Tones map onto the
 * app's semantic tokens (success/warning/destructive/info), so every status
 * color holds up in dark mode without per-usage plumbing.
 *
 * Lives apart from the components (react-refresh wants component files to
 * export only components).
 */
export type PillTone = 'ok' | 'warn' | 'crit' | 'neutral' | 'info';

/** Loose backend/status → tone mapping shared by the tabs. */
export function toneFor(value: string | undefined | null): PillTone {
  const v = String(value ?? '').toLowerCase();
  if (/(good|ok|pass|yes|scale|low|tailwind|positive|success|healthy)/.test(v)) return 'ok';
  if (/(partial|warn|medium|optimize|moderate|caution)/.test(v)) return 'warn';
  if (/(poor|crit|fail|no\b|pause|high|severe|destructive|risk)/.test(v)) return 'crit';
  if (/(info|track|monitor)/.test(v)) return 'info';
  return 'neutral';
}

/** Letter grade → tone: A/B read healthy, C warns, D/F critical. */
export function gradeTone(grade: string): PillTone {
  const g = grade.trim().charAt(0).toUpperCase();
  if (g === 'A' || g === 'B') return 'ok';
  if (g === 'C') return 'warn';
  if (g === 'D' || g === 'F') return 'crit';
  return 'neutral';
}
